import * as React from 'react'
import { useSearchParams } from 'react-router'

import { TIMEFRAME } from '../../../app/charts-lib'
import { QuoteQuery, QuoteSubview, QuoteView } from './types'
import { getQuoteSubview, getQuoteView } from './utils'

export const QuoteContext = React.createContext<{
  index: number
  ticker: string
  period: TIMEFRAME
  view: QuoteView | null
  subview: QuoteSubview | null
}>({ index: -1, ticker: '', period: TIMEFRAME.d, view: null, subview: null })

export function QuoteContextProvider({
  ticker,
  index,
  children,
}: React.PropsWithChildren<{ ticker: string; index: number }>) {
  const [query] = useSearchParams()
  const type = query.get(QuoteQuery.Type) as QuoteView | QuoteSubview
  const period = query.get(QuoteQuery.Period) as TIMEFRAME
  const contextValue = React.useMemo(
    () => ({ index, ticker, period, view: getQuoteView(type), subview: getQuoteSubview(type) }),
    [index, period, ticker, type]
  )

  return <QuoteContext.Provider value={contextValue}>{children}</QuoteContext.Provider>
}
